// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2681":"2144d51f","3139":"ad6a2716","3640":"c66cb2e4","3883":"e4c55a8e","7021":"e4c55a8e","9703":"2144d51f"}[chunkId] + ".chunk.css";
};